var heading_default = {
  "fontElementMap": "_6BD4U",
  "elementSpacing": "TaEV2",
  "headerOne": "EHW0m TaEV2",
  "headerTwo": "I4Nmm TaEV2",
  "headerThree": "gcl6V TaEV2",
  "headerFour": "I-TvZ TaEV2",
  "headerFive": "UbPlO TaEV2",
  "headerSix": "_6Q0gR TaEV2",
  "child": "_3wpkR"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
